import React from 'react';

/**
 * A "− value +" stepper used for the board layout controls (columns, text size).
 *
 * The Live Orders board, its focus-mode HUD and the Buffet board each style
 * their toolbar chrome differently, so the variant only swaps class names — the
 * behaviour, keyboard handling and ARIA labelling stay identical everywhere.
 * Tapping the value in the middle resets that setting.
 */
const VARIANTS = {
  kds:   { wrap: 'kds__zoom-ctrl',  btn: 'kds__zoom-btn', val: 'kds__zoom-pct kds__zoom-pct--wide' },
  focus: { wrap: 'td__focus-zoom',  btn: 'td__fz-btn',    val: 'td__fz-pct' },
  bf:    { wrap: 'bf__zoom-ctrl',   btn: 'bf__zoom-btn',  val: 'bf__zoom-pct bf__zoom-pct--wide' },
};

export function Stepper({
  ico, value, label, variant = 'kds',
  onLess, onMore, onReset,
  lessTitle, moreTitle, resetTitle,
  lessDisabled = false, moreDisabled = false,
}) {
  const cls = VARIANTS[variant] || VARIANTS.kds;
  return (
    <div className={cls.wrap} title={label}>
      <span className="kds__step-ico" aria-hidden="true">{ico}</span>
      <button className={cls.btn} onClick={onLess} disabled={lessDisabled}
        title={lessTitle} aria-label={lessTitle}>−</button>
      <span className={cls.val} onClick={onReset} title={resetTitle}
        role="button" tabIndex={0}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onReset(); } }}>
        {value}
      </span>
      <button className={cls.btn} onClick={onMore} disabled={moreDisabled}
        title={moreTitle} aria-label={moreTitle}>+</button>
    </div>
  );
}
